//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file dxos/keys.proto.
 */
export const file_dxos_keys = /*@__PURE__*/ fileDesc("Cg9keG9zL2tleXMucHJvdG8SCWR4b3Mua2V5cyIZCglQdWJsaWNLZXkSDAoEZGF0YRgBIAEoDCIaCgpQcml2YXRlS2V5EgwKBGRhdGEYASABKAxCKlooZ2l0aHViLmNvbS9keG9zL2R4b3MvcHJvdG8vZGVmL2R4b3Mva2V5c2IGcHJvdG8z");
/**
 * Describes the message dxos.keys.PublicKey.
 * Use `create(PublicKeySchema)` to create a new message.
 */
export const PublicKeySchema = /*@__PURE__*/ messageDesc(file_dxos_keys, 0);
/**
 * Describes the message dxos.keys.PrivateKey.
 * Use `create(PrivateKeySchema)` to create a new message.
 */
export const PrivateKeySchema = /*@__PURE__*/ messageDesc(file_dxos_keys, 1);
//# sourceMappingURL=keys_pb.js.map